import { fromJS, Map } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'

const initialState = fromJS({})

function mediaReducer(state = initialState, action) {
  let newState = state

  switch (action.type) {
    case actionTypes.GET_MEDIA_OF_MONTH:
      return state
        .set('gettingMediaOfMonth', true)
        .set('getMediaOfMonthError', null)
    case actionTypes.CLEAR_MEDIA:
      return state
        .set('gettingProjectMedia', false)
        .set('totalElements', 0)
        .set('totalPages', 0)
        .set('media', new Map({}))
    case actionTypes.GET_MEDIA_OF_MONTH_DONE:
      return state
        .set('gettingMediaOfMonth', false)
        .setIn(
          ['media', `${action.year}${action.month}`, action.page],
          action.media
        )
    case actionTypes.GET_MEDIA_OF_MONTH_ERROR:
      return state
        .set('gettingMediaOfMonth', false)
        .set('getMediaOfMonthError', action.error)

    case actionTypes.GET_MEDIA_FOR_ISSUE_OF_MONTH:
      return state
        .set('gettingMediaForIssueOfMonth', true)
        .set('getMediaForIssueOfMonthError', null)
    case actionTypes.CLEAR_ISSUE_MEDIA:
      return state.set('issueMedia', new Map({}))
    case actionTypes.GET_MEDIA_FOR_ISSUE_OF_MONTH_DONE:
      return state
        .set('gettingMediaForIssueOfMonth', false)
        .setIn(
          ['issueMedia', `${action.year}${action.month}`, action.page],
          action.media
        )
    case actionTypes.GET_MEDIA_FOR_ISSUE_OF_MONTH_ERROR:
      return state
        .set('gettingMediaForIssueOfMonth', false)
        .set('getMediaForIssueOfMonthError', action.error)

    case actionTypes.GET_PROJECT_MEDIA:
      return state
        .set('gettingProjectMedia', true)
        .set('getProjectMediaError', null)
    case actionTypes.GET_PROJECT_MEDIA_DONE:
      return state
        .set('gettingProjectMedia', false)
        .set('totalElements', action.totalElements)
        .set('totalPages', action.totalPages)
        .setIn(['media', action.page], fromJS(action.media))
    case actionTypes.GET_PROJECT_MEDIA_ERROR:
      return state
        .set('gettingProjectMedia', false)
        .set('getProjectMediaError', action.error)

    case actionTypes.SET_PROJECT_MEDIA_ACTIVE_STATE:
      if (state.has('media')) {
        state.get('media').forEach((mediaPage, pageIndex) => {
          const found = mediaPage.toJS().find((file, mediaIndexInPage) => {
            if (file.id === action.fileId) {
              newState = state.setIn(
                ['media', pageIndex, mediaIndexInPage, 'active'],
                action.status
              )
              return true
            }
            return false
          })
          return found !== -1
        })
      }

      return newState

    case actionTypes.DOWNLOAD_FILES_AS_ZIP:
      return state
        .delete('bulkDownloadStorageId')
        .delete('bulkDownloadError')
        .delete('bulkDownloadFailed')
        .delete('bulkDownloadPercentage')
        .delete('bulkDownloadDone')
        .set('bulkDownloadName', action.projectName)
    case actionTypes.DOWNLOAD_FILES_AS_ZIP_DONE:
      return state
        .set('bulkDownloadDone', true)
        .set('bulkDownloadPercentage', 100)
    case actionTypes.DOWNLOAD_FILES_AS_ZIP_SET_PERCENTAGE:
      return state.set('bulkDownloadPercentage', action.percentage)
    case actionTypes.DOWNLOAD_FILES_AS_ZIP_SET_STORAGE_ID:
      return state.set('bulkDownloadStorageId', action.storageId)
    case actionTypes.DOWNLOAD_FILES_AS_ZIP_ERROR:
      return state.set('bulkDownloadError', action.error)
    case actionTypes.DOWNLOAD_FILES_AS_ZIP_FAILED:
      return state.set('bulkDownloadFailed', true)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default mediaReducer
